import {NgModule} from "@angular/core";
import {MyCampaignsBtnComponent} from "./my-campaigns-btn/my-campaigns-btn";
import {IonicModule} from "ionic-angular";
import {ItemDescription} from "./item-description/item-description";
import {PipesModule} from "../pipes/pipes.module";

@NgModule({
  declarations: [MyCampaignsBtnComponent, ItemDescription],
  imports: [IonicModule, PipesModule],
  exports: [MyCampaignsBtnComponent, ItemDescription],
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts